import { useEffect } from 'react';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import customTheme from '~/styles/theme';

export const FontOverride = () => {
  const { isEnabled } = useFeature(FEATURE_FLAGS.foamFontOverrideComicSans);

  useEffect(() => {
    if (!isEnabled) {
      document.body.style.fontFamily = customTheme.fonts.body;
      return;
    }

    // Make comic sans the default font for the body
    document.body.style.fontFamily = 'Comic Sans MS, Comic Sans, cursive';
  }, [isEnabled]);

  return null;
};
